/**
 * MT Image List 1
 * 功能：水平滚动导航、本地视频控制、YouTube 交互
 */
class MTImageList1 {
  constructor(container) {
    this.container = container;
    this.scrollContainer = container.querySelector('.mt-image-list1__scroll');
    this.prevBtn = container.querySelector('.mt-image-list1__nav--prev');
    this.nextBtn = container.querySelector('.mt-image-list1__nav--next');
    this.cards = container.querySelectorAll('.mt-image-list1__card');
    
    // 如果关键元素缺失，则不初始化
    if (!this.scrollContainer || !this.prevBtn || !this.nextBtn) return;
    
    this.init();
  }

  init() {
    this.updateNavButtons();
    this.bindScrollEvents();
    this.initMedia();
  }

  // --- 1. 滚动与导航逻辑 ---
  bindScrollEvents() {
    this.prevBtn.addEventListener('click', () => this.scroll('prev'));
    this.nextBtn.addEventListener('click', () => this.scroll('next'));

    let scrollTimeout;
    this.scrollContainer.addEventListener('scroll', () => {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => this.updateNavButtons(), 50);
    });

    window.addEventListener('resize', () => {
      this.updateNavButtons();
    });
  }

  scroll(direction) {
    const card = this.cards[0];
    if (!card) return;
    
    const cardWidth = card.offsetWidth;
    const gap = 24; 
    const scrollAmount = cardWidth + gap;
    const targetScroll = this.scrollContainer.scrollLeft + (direction === 'next' ? scrollAmount : -scrollAmount);

    this.scrollContainer.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }

  updateNavButtons() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
    const tolerance = 5;

    const isAtStart = scrollLeft <= tolerance;
    this.toggleBtn(this.prevBtn, !isAtStart);

    const isAtEnd = scrollLeft + clientWidth >= scrollWidth - tolerance;
    this.toggleBtn(this.nextBtn, !isAtEnd);
  }

  toggleBtn(btn, show) {
    if (show) {
      btn.disabled = false;
      btn.style.opacity = '1';
      btn.style.visibility = 'visible';
      btn.style.pointerEvents = 'auto';
    } else {
      btn.disabled = true;
      btn.style.opacity = '0';
      btn.style.visibility = 'hidden';
      btn.style.pointerEvents = 'none';
    }
  }

  // --- 2. 媒体交互逻辑 ---
  initMedia() {
    this.cards.forEach(card => {
      const video = card.querySelector('video.mt-image-list1__video');
      const videoWrapper = card.querySelector('.mt-image-list1__video-wrapper');
      const playBtn = card.querySelector('.mt-image-list1__play-btn');

      // 2.1 本地 MP4
      if (video) {
        card.addEventListener('mouseenter', () => {
          try {
            video.muted = true;
            const p = video.play();
            if (p !== undefined) {
              p.catch(e => { if (e.name !== 'AbortError') console.error('Play failed:', e); });
            }
            this.setPlayingState(card, true);
          } catch (e) {}
        });

        card.addEventListener('mouseleave', () => {
          video.pause();
          video.currentTime = 0;
          this.setPlayingState(card, false);
        });

        if (playBtn) {
          playBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (video.paused) {
              video.muted = false;
              video.play();
              this.setPlayingState(card, true);
            } else {
              video.pause();
              this.setPlayingState(card, false);
            }
          });
        }
      }

      // 2.2 YouTube (动态 Iframe)
      if (videoWrapper && videoWrapper.dataset.videoType === 'youtube') {
        const videoId = videoWrapper.dataset.videoId;
        let iframe = null;

        const createIframe = (autoplay, mute, controls) => {
          const f = document.createElement('iframe');
          f.className = 'mt-image-list1__video-iframe';
          f.src = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&rel=0&modestbranding=1&controls=${controls ? 1 : 0}&autoplay=${autoplay ? 1 : 0}&mute=${mute ? 1 : 0}`;
          f.setAttribute('frameborder', '0');
          f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          f.allowFullscreen = true;
          return f;
        };

        card.addEventListener('mouseenter', () => {
          if (!iframe) {
            iframe = createIframe(true, true, false);
            videoWrapper.appendChild(iframe);
            this.setPlayingState(card, true);
          }
        });

        card.addEventListener('mouseleave', () => {
          if (iframe) {
            iframe.remove();
            iframe = null;
            this.setPlayingState(card, false);
          }
        });

        if (playBtn) {
          playBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (!iframe) {
              iframe = createIframe(true, false, true);
              videoWrapper.appendChild(iframe);
              this.setPlayingState(card, true);
            } else {
              iframe.remove();
              iframe = createIframe(true, false, true);
              videoWrapper.appendChild(iframe);
              this.setPlayingState(card, true);
            }
          });
        }
      }
    });
  }

  setPlayingState(card, isPlaying) {
    const playBtn = card.querySelector('.mt-image-list1__play-btn');
    const poster = card.querySelector('.mt-image-list1__video-poster');
    
    if (isPlaying) {
      if (playBtn) playBtn.classList.add('playing');
      if (poster) poster.classList.add('playing');
      card.classList.add('video-playing');
    } else {
      if (playBtn) playBtn.classList.remove('playing');
      if (poster) poster.classList.remove('playing');
      card.classList.remove('video-playing');
    }
  }
}

// 初始化
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.mt-image-list1');
  containers.forEach(container => new MTImageList1(container));
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.mt-image-list1');
    if (container) {
      new MTImageList1(container);
    }
  });
}